// 답변 마크다운 → 소리 내 읽을 평문 (backend services/chat_voice_service.py speech_text 와 같은 규칙)
export const toSpeechText = (markdown) => {
  let t = String(markdown || '');
  t = t.replace(/```[\s\S]*?```/g, ' ');
  t = t.replace(/<[^>]+>/g, ' ');
  t = t.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ');
  t = t.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
  t = t.replace(/https?:\/\/\S+/g, ' ');
  t = t.replace(/^\s*\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)*\|?\s*$/gm, ' ');
  t = t.replace(/\|/g, ' ');
  t = t.replace(/^\s{0,3}#{1,6}\s*/gm, '');
  t = t.replace(/^\s*[-*+]\s+/gm, '');
  t = t.replace(/^\s*>\s?/gm, '');
  t = t.replace(/(\*\*|__|\*|_|~~|`)/g, '');
  t = t.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu, '');
  t = t.replace(/\n{2,}/g, '\n');
  t = t.replace(/[ \t]+/g, ' ');
  return t.replace(/ *\n */g, '\n').trim();
};

export const SPEECH_SEGMENT_MAX = 500;
export const SPEECH_TOTAL_MAX = 6000;

const splitLongSentence = (sentence, max) => {
  const pieces = [];
  let rest = sentence;
  while (rest.length > max) {
    const window = rest.slice(0, max);
    const cut = Math.max(window.lastIndexOf(', '), window.lastIndexOf(' '));
    const at = cut > max * 0.5 ? cut + 1 : max;
    pieces.push(rest.slice(0, at).trim());
    rest = rest.slice(at).trim();
  }
  if (rest) pieces.push(rest);
  return pieces;
};

// 문장 단위 조각. 줄바꿈은 제목·목록 끝의 쉼을 살리려고 그대로 두고, 같은 줄 문장은 띄어쓰기로 잇는다.
// startsLine=false 이면 첫 조각이 앞 글의 같은 줄에 이어지는 문장이다(스트리밍 중 문장 단위로 끊어 받을 때).
export const splitSpeechUnits = (text, { max = SPEECH_SEGMENT_MAX, startsLine = true } = {}) => (
  String(text || '').split('\n').flatMap((line, lineIndex) => (
    (line.match(/.+?(?:[.!?。…]+(?=\s|$)|$)/g) || [])
      .map((s) => s.trim())
      .filter(Boolean)
      .flatMap((s) => (s.length > max ? splitLongSentence(s, max) : [s]))
      .map((unit, index) => ({
        text: unit,
        separator: index === 0 && (lineIndex > 0 || startsLine) ? '\n' : ' ',
      }))
  ))
);

// 앞에서부터 max 글자까지 묶어 서버 한 번 요청 분량을 만든다.
export const takeSpeechSegment = (units, max = SPEECH_SEGMENT_MAX) => {
  let segment = '';
  let used = 0;
  for (const { text, separator } of units) {
    const joined = segment ? `${segment}${separator}${text}` : text;
    if (segment && joined.length > max) break;
    segment = joined;
    used += 1;
  }
  return { segment, rest: units.slice(used) };
};

// 서버 한 번 요청(최대 600자)에 맞게 문장 경계에서 나눈다. 너무 긴 답변은 앞부분만 읽는다.
export const splitSpeechSegments = (text, { max = SPEECH_SEGMENT_MAX, totalMax = SPEECH_TOTAL_MAX } = {}) => {
  const source = String(text || '').trim();
  if (!source) return { segments: [], truncated: false };
  const truncated = source.length > totalMax;
  const body = truncated ? source.slice(0, totalMax) : source;
  let units = splitSpeechUnits(body, { max });
  const segments = [];
  while (units.length) {
    const { segment, rest } = takeSpeechSegment(units, max);
    segments.push(segment);
    units = rest;
  }
  return { segments, truncated };
};

// 스트리밍 중인 답변에서 이미 끝난 부분(완성된 줄 + 마지막 줄의 끝난 문장)만 돌려준다.
// 닫히지 않은 코드 블록은 빼고, "1." 같은 번호는 문장 끝으로 보지 않는다.
export const settledSpeechMarkdown = (markdown, { final = false } = {}) => {
  const source = String(markdown || '');
  let settled = source;
  if (!final) {
    let cut = source.lastIndexOf('\n') + 1;
    const tail = source.slice(cut);
    const sentenceEnds = [...tail.matchAll(/[^\d\s][.!?。…]+(?=\s)/g)];
    if (sentenceEnds.length) {
      const last = sentenceEnds[sentenceEnds.length - 1];
      cut += last.index + last[0].length;
    }
    settled = source.slice(0, cut);
  }
  const fences = settled.match(/```/g);
  if (fences && fences.length % 2 === 1) settled = settled.slice(0, settled.lastIndexOf('```'));
  return settled;
};
